import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

const orgKey = 'org_id'

export function getOrgId() {
    var v = Cookies.get(orgKey)
    if (v)
        v = parseInt(v)
    return v
}

export function setOrgId(org_id) {
    return Cookies.set(orgKey, org_id)
}

export function removeOrgId() {
    return Cookies.remove(orgKey)
}

const shopKey = 'shop_id'

export function getShopId() {
    var v = Cookies.get(shopKey)
    if (v)
        v = parseInt(v)
    return v
}

export function setShopId(shop_id) {
    return Cookies.set(shopKey, shop_id)
}

export function removeShopId() {
    return Cookies.remove(shopKey)
}

const tmpKey = 'template_id'

export function getTemplateId() {
    var v = Cookies.get(tmpKey)
    if (v)
        v = parseInt(v)
    return v
}

export function setTemplateId(verify2template) {
    return Cookies.set(tmpKey, verify2template)
}

export function removeTemplateId() {
    return Cookies.remove(tmpKey)
}


export function password_verify(pwd){
	let pattern0 =/^[0-9a-zA-Z!@#$%^&*_\-=+]{8,}$/;
	let pattern1 =/[a-z]/;
	let pattern2 =/[0-9]/;
	let pattern3 =/[!@#$%^&*_\-=+]/;
	let pattern4 =/[A-Z]/;
	let ret0 = pattern0.exec(pwd);
	let ret1 = pattern1.exec(pwd);
	let ret2 = pattern2.exec(pwd);
	let ret3 = pattern3.exec(pwd);
	let ret4 = pattern4.exec(pwd);
	if (ret0 == null){
		return false;
	}
	let num = 0;
	if (ret1 != null){
		num += 1;
	}
	if (ret2 != null){
		num += 1;
	}
	if (ret3 != null){
		num += 1;
	}
	if (ret4 != null){
		num += 1;
	}
	return num >= 3;
}